import React from 'react';
import { useOnce, useUserStateRedux } from '../../../../hooks';
import { SS_MESSAGING_SMS_OPTED_IN } from '../../providerProfile/constants';
import { getUserSettings, saveUserSettings } from '../../../../modules/user/phoneSettings';
import analytics from '../../../../modules/analytics';
import { State as UserModelState } from '../../../../store/CurrentUser.types';
import { NotifyMeRequestForChatForm } from './NotifyMeRequestForChatForm';

interface NotifyMeRequestForChatFormContainerProps {
  trackingParams: Record<string, any>;
  onSuccess: () => void;
  user: UserModelState;
  headerText: React.ReactNode;
}

const optInLanguage = 'Yes, send me recurring automated text messages to notify me about new messages received through StyleSeat Messaging. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg and data rates may apply.';
const phoneNumberFooterText = ' ';

// eslint-disable-next-line max-len
export const NotifyMeRequestForChatFormContainer: React.FCWithChildren<NotifyMeRequestForChatFormContainerProps> = ({
  trackingParams,
  onSuccess,
  user,
  headerText,
}) => {
  const [, setOptIn] = useUserStateRedux(SS_MESSAGING_SMS_OPTED_IN);

  useOnce(() => {
    analytics.track('client_notify_me_for_chat_phone_viewed', trackingParams);
  }, trackingParams);

  const handleNextButtonClick = async (phoneNumber: string) => {
    const userPhoneSettings = await getUserSettings(user.user_id);

    analytics.track('client_notify_me_phone_for_chat_clicked', trackingParams);
    // payload may need to update based on lifecycle requirements. ( for future tickets);
    const payload = {
      name: user.username,
      mobile_phone_number: phoneNumber,
      source: 'lmc_notify_request_for_chat_add_phone_modal',
      appointment_sms_enabled: userPhoneSettings.appointment_sms_enabled,
      ss_messaging_sms_enabled: true,
    };

    await saveUserSettings(user.user_id, payload);

    analytics.track('lmc_notify_request_for_chat_add_phone_click');

    setOptIn(true);

    onSuccess();
  };

  return (
    <NotifyMeRequestForChatForm
      headerText={headerText}
      optInLanguage={optInLanguage}
      phoneNumberFooterText={phoneNumberFooterText}
      phoneNumber={user.phone_number}
      onClickContinue={handleNextButtonClick}
    />
  );
};
